import { z } from 'zod/v4';
import { CreditorState } from '../../creditor/index.js';
import { Lang } from '../../lang/Lang.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { channelsSchema, contactChannelSchema } from './channel-shape.js';
import { propertyItemSchema } from './property-shape.js';
const inputSchema = z.object({});
const outputSchema = z.object({
    referenceId: z.string().nullable(),
    name: z.string(),
    preferredLanguage: z.enum(Lang).nullable(),
    isCompany: z.boolean(),
    state: z.enum(CreditorState),
    country: z.string().nullable(),
    creditorType: z.string().nullable(),
    notes: z.string().nullable(),
    debtorFAQ: z.string().nullable(),
    channels: channelsSchema(contactChannelSchema),
    properties: z.array(propertyItemSchema),
});
export const getCreditorTool = {
    name: ToolName.GetCreditor,
    category: ToolCategory.CaseInfo,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Read the creditor on this case. Read this before proposing create_creditor_message — caseworkers often need to ask the creditor for documentation or clarification. The creditor's preferredLanguage tells you what language to write in.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-creditor.js.map